import Icon, { SearchOutlined } from '@ant-design/icons';
import { noticeRelation, queryRelationNotice } from '@api/announcement';
import EmptyIcon from '@assets/image/empty.svg';
import LoudspeakerIcon from '@assets/image/loudspeaker.svg';
import ZeissInput from '@components/input';
import ZeissModal from '@components/zeiss-modal';
import { ROLE_KEYS_MAP } from '@constants';
import { userInfo } from '@store';
import { ActionTypeEnum } from '@views/pages/AnnouncementDetails/type';
import { Empty, Tag, message } from 'antd';
import { useEffect, useMemo, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import { caretSvg, noticeSvg, noticeTypeClassMap } from './data';
import './index.scss';

export const useRelatedAnnouncement = ({ details = {}, getAnnInfo }: any) => {
  const { groups, dataFlag } = details;
  const [open, setOpen] = useState(false);
  const [currentNoticeObj, setCurrentNoticeObj] = useState<any>(null);
  const [relationActionType] = useState<ActionTypeEnum>(ActionTypeEnum.related);
  const [collapseItemsArr, setCollapseItemsArr] = useState<any>([]);
  const [emptyData, setEmptyData] = useState<any>([]);
  const inputFilterRef = useRef<any>(null);
  const navigate = useNavigate();
  const [userInfos] = useRecoilState(userInfo);

  const subTitle = useMemo(() => {
    if (userInfos.roleKeys === ROLE_KEYS_MAP.sales) {
      return '';
    }
    return groups?.length
      ? '系统自动判断下方的公告与当前的公告属于同一个招标项目。如果当前公告与下方不属于同一个招标项目，请点击取消关联。'
      : '系统没有发现与本公告同一个招标项目下的其它公告。如果有的话，请关联前序公告，以避免重复创建项目。';
  }, [groups]);

  const gotoDetailPage = (data: any) => {
    const { noticeCode } = data;
    navigate(`/announcement/announcementDetail?noticeId=` + noticeCode, {
      replace: true
    });
  };

  // 折叠面板展开的内容
  const collapseItemChildrenRender = (
    data: any = [],
    isEmptyToggle: boolean = false
  ) => {
    return (
      <div className="announcement_collapse_wrap">
        {data.map((item: any) => {
          const {
            noticeCode,
            noticeName,
            noticeType,
            noticeTypeValue,
            publishTime,
            currentNotice
          } = item;
          return (
            <div className="announcement_collapse_item" key={noticeCode}>
              <div className="item_row">
                <div
                  className={`notice_name ${currentNotice ? 'current' : ''}`}
                >
                  <Icon
                    component={() =>
                      noticeSvg(currentNotice ? '#606A76' : '#0072EF')
                    }
                    className="notice_icon"
                  />
                  <div
                    onClick={() => gotoDetailPage(item)}
                    style={{ cursor: 'pointer' }}
                  >
                    {isEmptyToggle ? formatLabelDom(noticeName) : noticeName}
                  </div>
                </div>
                {currentNotice && (
                  <div className="current_announcement">● 当前公告</div>
                )}
              </div>
              <div className="item_row">
                <div>
                  <Tag className={`${noticeTypeClassMap[noticeType]}`}>
                    {noticeTypeValue}
                  </Tag>
                </div>
                <div className="time">{publishTime}</div>
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  useEffect(() => {
    setCollapseItemsArr(groups ?? []);
  }, [groups]);

  const formatLabelDom = (label: string = '') => {
    const keyword = inputFilterRef.current?.input?.value || '';
    let labelDom = label.replace(
      new RegExp(keyword, 'g'),
      `<span class="announcemen_header_strong">${keyword}</span>`
    );

    return <div dangerouslySetInnerHTML={{ __html: labelDom }}></div>;
  };

  // 折叠面板内容
  const collapseItemRender = (
    item: any,
    index: number,
    isEmptyToggle: boolean = false
  ) => {
    const { isActive, groupCode, groupName, notices } = item;
    return (
      <div className="announcement_collapse" key={groupCode}>
        <div className="announcement_collapse_header">
          <div
            className="collapse_header_text"
            onClick={() => collapseToggle(index, isEmptyToggle)}
          >
            <Icon
              component={caretSvg}
              className={`${isActive ? '' : 'collapse-active'} collapse_icon`}
            />
            <img src={LoudspeakerIcon} alt="" style={{ marginRight: 6 }} />
            {isEmptyToggle ? formatLabelDom(groupName) : groupName}
          </div>
          {/* {userInfos.roleKeys !== ROLE_KEYS_MAP.sales && (
            <div className="announcement_operation">
              {relationStatus ? (
                <ZeissButton
                  type="link"
                  danger
                  onClick={() => cancelRelation(item)}
                >
                  取消关联
                </ZeissButton>
              ) : (
                <ZeissButton type="link" onClick={() => linkRelation(item)}>
                  关联公告组
                </ZeissButton>
              )}
            </div>
          )} */}
        </div>
        {isActive && collapseItemChildrenRender(notices, isEmptyToggle)}
      </div>
    );
  };

  const collapseItemContent = useMemo(() => {
    return collapseItemsArr?.map((item: any, index: number) =>
      collapseItemRender(item, index)
    );
  }, [collapseItemsArr]);

  const handleInputSubmit = async () => {
    const keyword = inputFilterRef.current?.input?.value || '';
    // 限制为空搜索时会搜出全部公告
    if (!keyword) {
      setEmptyData([]);
      return;
    }
    const res: any = await queryRelationNotice({
      keyword,
      dataFlag
    });
    setEmptyData(res?.groups || []);
  };

  const collapseEmptyContent = useMemo(() => {
    return (
      <div className="empty_wrap">
        <div className="empty_search_wrap">
          <div>{emptyData.length ? `${emptyData.length}条搜索结果` : ''}</div>
          <ZeissInput
            placeholder="请输入关键词搜索"
            allowClear
            style={{ width: 240, marginRight: 20 }}
            onPressEnter={handleInputSubmit}
            ref={inputFilterRef}
            suffix={<SearchOutlined onClick={handleInputSubmit} />}
          />
        </div>

        {emptyData.length ? (
          emptyData.map((item: any, index: number) =>
            collapseItemRender(item, index, true)
          )
        ) : (
          <Empty
            className="empty_block"
            image={<img src={EmptyIcon} width={100} alt="" />}
            description="暂无相似公告？请搜索或直接给销售"
          ></Empty>
        )}
      </div>
    );
  }, [emptyData]);

  const collapseToggle = (index: number, isEmptyToggle: boolean = false) => {
    const curArr = (isEmptyToggle ? emptyData : collapseItemsArr) || [];
    const newArr = curArr?.map((item: any, i: number) => {
      if (i === index) {
        item.isActive = !item.isActive;
      }
      return item;
    });
    isEmptyToggle ? setEmptyData(newArr) : setCollapseItemsArr(newArr);
  };

  // const cancelRelation = (item: any) => {
  //   setCurrentNoticeObj(item);
  //   setRelationActionType(ActionTypeEnum.unrelated);
  //   setOpen(true);
  // };

  // const linkRelation = (item: any) => {
  //   setCurrentNoticeObj(item);
  //   setRelationActionType(ActionTypeEnum.related);
  //   setOpen(true);
  // };

  const onModalCancel = () => {
    setOpen(false);
    setCurrentNoticeObj(null);
  };

  const onModalOk = async () => {
    setOpen(false);
    const { groupCode } = currentNoticeObj;
    const { noticeCode } = details;

    const res = await noticeRelation({
      groupCode,
      noticeCode,
      action: relationActionType
    });

    if (res?.dispatchSales) {
      message.success('关联的公告已经分配了销售，本公告不需要重新指派销售');
    } else {
      message.success(
        relationActionType === ActionTypeEnum.related
          ? '关联成功'
          : '取消关联成功'
      );
    }
    setCurrentNoticeObj(null);
    getAnnInfo?.();
    setEmptyData([]);
  };

  const relatedAnnouncementComponent = collapseItemsArr.length ? (
    <div className="pc-related-announcement">
      <div className="pc-sub-tit">已关联公告</div>
      <div className="pc-sub-text">{subTitle}</div>
      <div className="announcement_main">
        {groups?.length ? collapseItemContent : collapseEmptyContent}
      </div>
      <ZeissModal
        open={open}
        centered
        title={`${
          relationActionType === ActionTypeEnum.related
            ? '是否确关联?'
            : '是否确认取消关联?'
        }`}
        onCancel={onModalCancel}
        onOk={onModalOk}
      ></ZeissModal>
    </div>
  ) : null;
  return {
    relatedAnnouncementComponent
  };
};
